import {uploadFile} from "@/api";
import {fileUpUrl} from "@/config";

export const uploadImageAdapter = (file) => {
    let param = new FormData(); //创建form对象
    param.append('file',file);//通过append向form对象添加数据
    // param.append('fname', getQNFileName(file.name));//通过append向form对象添加数据
    // param.append('key',getQNFileKey(file.name));//通过append向form对象添加数据
    // param.append('token',getQNToken());//通过append向form对象添加数据
    return uploadFile(fileUpUrl,param)
}